'use strict';

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    ParkingMapController.$inject = ['$interval', '$q', 'iotService'];
    angular.module('app.admin').component('parkingMap2', {
        controller: ParkingMapController,
        controllerAs: '$ctrl'
    });

    function ParkingMapController($interval, $q, iotService) {
        'ngInject';

        var $ctrl = this;

        ////////////////

        /**
         * 
         */
        $ctrl.$onInit = function () {

            $q.all({
                devices: iotService.getParkingDevices()
            }).then(function (r) {}).catch(function (error) {
                console.error(error);
            });
        };

        $ctrl.$onDestroy = function () {};

        /**
         * 
         */
        function update() {

            $q.all({
                devices: iotService.getParkingDevices()
            }).then(function (r) {}).catch(function (error) {
                if (error.status === 401) {
                    $state.go('login');
                }
                console.error(error);
            });
        }
    }
})();